export { Label, labelVariants } from './Label'
export type { LabelProps } from './Label'
